import styled from 'styled-components';
import { Link as LinkUI } from 'components/Atoms';

export const Footer = styled.footer`
  padding: 80px 16px;
  display: flex;
  flex-direction: column;
  grid-gap: 32px;
  align-items: center;
  justify-content: center;
`;

export const Links = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  align-items: center;
  justify-content: center;
  grid-gap: 32px;
  flex-wrap: wrap;
`;

export const Link = styled(LinkUI)`
  ${props => props}
  position: relative;

  ::after {
    position: absolute;
    content: '';
    top: calc(50% - 2px);
    right: -18px;
    display: ${props => !props.column || !props.hasDot ? 'none' : 'block'};
    width: 4px;
    height: 4px;
    border-radius: ${props => props.theme.old.rounded.circle};
    background-color: ${props => props.theme.old.colors.secondary};
  }

  :hover {
    color: white;
    opacity: .5;
  }
`;
